export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suchen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie befinden sich im Demo-Modus. Salden und Operationen sind Übungsdaten."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Arbeitsbereich wechseln"])}
}